module.exports = __webpack_public_path__ + "img/logo@2x.4fc84bdc.png";